export default __webpack_public_path__ + "static/media/business-problem5-en.6fa1257e.png";